module.exports = __webpack_public_path__ + "static/img/showcase_komaneko.cdfbf15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase_komaneko.png
// module id = 755
// module chunks = 1